import { render, staticRenderFns } from "./OverviewSection.vue?vue&type=template&id=b63823fe&"
import script from "./OverviewSection.vue?vue&type=script&lang=js&"
export * from "./OverviewSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b63823fe')) {
      api.createRecord('b63823fe', component.options)
    } else {
      api.reload('b63823fe', component.options)
    }
    module.hot.accept("./OverviewSection.vue?vue&type=template&id=b63823fe&", function () {
      api.rerender('b63823fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/OverviewSection.vue"
export default component.exports